/* ═══════════════════════════════════════════════════════════════════════════
   eoh-live-screen.js  ·  EOH Live Screen — understanding layer (frontend)

   Runs the understanding stage (Did you mean…? → phase map → selective guidance)
   BEFORE the existing step-by-step guide. Loads AFTER live-screen-guide_client.js.

   Integrates by wrapping the existing client (no rewrite):
     • EOHGuide.mountPanel(d)  → also mounts the compact workspace panel
     • EOHGuide.startGuide(q)  → routes through /live-screen/understand first
     • EOHGuide.captureFrame() → grabs the shared frame for understand/phases
     • EOHGuide._origStartGuide(detail) → guides ONE chosen phase (boxes/captions)

   Everything is compact, tucked, and COLLAPSIBLE to a side button — it never
   covers the working area. Phase list shows TITLES only. Nothing hardcoded.
   ═══════════════════════════════════════════════════════════════════════════ */
(function (global) {
  "use strict";
  if (global.__eohLiveScreenLoaded) return; global.__eohLiveScreenLoaded = true;

  var _dev = global.location.hostname !== 'erponlinehub.com';
  var API = (global.location.hostname === 'erponlinehub.com' && !_dev)
    ? 'https://erp-ai-backend.vercel.app' : 'https://erp-ai-backend-dev.vercel.app';

  var LS = { doc: null, sessionId: null, phases: [], activePhase: null, stage: 'idle', collapsed: false, lang: null };

  function tok() { try { return localStorage.getItem('eoh_t') || ''; } catch (e) { return ''; } }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  async function api(path, body) {
    try {
      var r = await global.fetch(API + path, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + tok() },
        body: JSON.stringify(body || {})
      });
      return await r.json();
    } catch (e) { return { error: e.message }; }
  }
  async function apiGet(path) {
    try { var r = await global.fetch(API + path, { headers: { 'Authorization': 'Bearer ' + tok() } }); return await r.json(); } catch (e) { return { error: e.message }; }
  }
  // Capture a frame directly from the shared stream — independent of the client edit,
  // so this works even if live-screen-guide.client.js wasn't re-deployed with captureFrame.
  async function _capture() {
    try {
      var ls = global._liveScreen;
      if (!ls || !ls.active || !ls.stream) return null;
      var track = ls.stream.getVideoTracks()[0];
      if (!track || track.readyState !== 'live') return null;
      var video = document.createElement('video');
      video.srcObject = ls.stream; video.muted = true;
      try { await video.play(); } catch (e) { return null; }
      var canvas = document.createElement('canvas');
      canvas.width = Math.min(video.videoWidth || 1280, 1280);
      canvas.height = Math.min(video.videoHeight || 720, 720);
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      video.pause(); video.srcObject = null;
      return canvas.toDataURL('image/jpeg', 0.6);
    } catch (e) { return null; }
  }
  async function frame() {
    try { if (global.EOHGuide && EOHGuide.captureFrame) { var f = await EOHGuide.captureFrame(); if (f) return f; } } catch (e) {}
    var f2 = await _capture(); if (f2) return f2;
    return (global.EOHGuide && EOHGuide.lastFrame) || null;
  }
  function lang() { try { return (global.S && global.S._chatLang) || LS.lang || 'en-US'; } catch (e) { return 'en-US'; } }

  var CSS =
    '#eohls-panel{font-family:inherit;background:rgba(17,24,33,.96);border:1px solid rgba(90,130,180,.35);border-radius:10px;margin:6px 8px;overflow:hidden;font-size:12px;color:#cfe0f0}' +
    '#eohls-head{display:flex;align-items:center;gap:6px;padding:6px 9px;background:rgba(30,42,60,.9);font-size:11px;font-weight:600;color:#9fb6cf;cursor:pointer}' +
    '#eohls-head .t{flex:1}' +
    '#eohls-min{background:none;border:none;color:#7d93ad;cursor:pointer;font-size:14px;line-height:1;padding:0 4px}' +
    '#eohls-body{padding:9px;max-height:230px;overflow-y:auto}' +
    '#eohls-reopen{position:fixed;top:8px;right:8px;z-index:99;background:#0a8a5f;color:#fff;border:none;border-radius:7px;padding:6px 10px;font-size:11px;font-weight:600;cursor:pointer;box-shadow:0 3px 10px rgba(0,0,0,.4)}' +
    '.eohls-opt{display:block;width:100%;text-align:left;font-size:12px;line-height:1.4;padding:7px 9px;margin-bottom:6px;border-radius:7px;cursor:pointer;border:1px solid rgba(90,130,180,.3);background:rgba(30,42,60,.7);color:#e2eefb}' +
    '.eohls-opt.rec{border-color:#0fb574;background:rgba(15,181,116,.12)}' +
    '.eohls-opt small{display:block;color:#8aa0b8;font-size:10px;margin-top:2px}' +
    '.eohls-ph{display:flex;align-items:center;gap:7px;width:100%;text-align:left;font-size:12px;padding:6px 8px;margin-bottom:5px;border-radius:7px;cursor:pointer;border:1px solid rgba(90,130,180,.25);background:rgba(30,42,60,.6);color:#e2eefb}' +
    '.eohls-ph .num{width:16px;height:16px;border-radius:50%;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;font-size:9px;background:rgba(90,130,180,.3);color:#cfe0f0}' +
    '.eohls-ph.done{opacity:.7}.eohls-ph.done .num{background:#0a8a5f;color:#fff}.eohls-ph.active{border-color:#0fb574;background:rgba(15,181,116,.12)}' +
    '.eohls-ph .ttl{flex:1}.eohls-ph .code{color:#7fb0ff;font-size:10px}' +
    '.eohls-btn{font-size:11px;padding:6px 11px;border-radius:7px;border:none;background:#0a8a5f;color:#fff;cursor:pointer}' +
    '.eohls-btn.ghost{background:rgba(30,42,60,.8);color:#cfe0f0;border:1px solid rgba(90,130,180,.3)}' +
    '.eohls-row{display:flex;gap:6px;flex-wrap:wrap;margin-top:6px}' +
    '.eohls-hint{font-size:10px;color:#8aa0b8;margin-bottom:6px}' +
    '.eohls-codehdr{display:flex;align-items:center;gap:6px;padding:5px 9px;background:rgba(30,42,60,.9);border:1px solid rgba(90,130,180,.3);border-bottom:none;border-radius:7px 7px 0 0}' +
    '.eohls-codehdr .lang{flex:1;font-size:10px;font-weight:600;letter-spacing:.4px;color:#79b8ff;text-transform:uppercase}' +
    '.eohls-codehdr button{background:none;border:none;color:#9fb6cf;cursor:pointer;font-size:10px;padding:2px 7px;border-radius:5px}' +
    '.eohls-codehdr button:hover{background:rgba(90,130,180,.2);color:#e2eefb}' +
    '.eohls-code{background:#0b1017;border:1px solid rgba(90,130,180,.3);border-radius:0 0 7px 7px;padding:9px 11px;margin:0 0 6px;font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;font-size:10.5px;line-height:1.65;white-space:pre;overflow:auto;color:#d6e6f5;max-height:210px;tab-size:2}' +
    '.eohls-code .k{color:#79b8ff;font-weight:600}.eohls-code .s{color:#8ddb8d}.eohls-code .c{color:#7d8ba3;font-style:italic}.eohls-code .n{color:#e6a55f}' +
    '.eohls-note{font-size:10px;color:#e0b050;line-height:1.45;margin-bottom:6px}' +
    '.eohls-warn{background:rgba(239,68,68,.12);border:1px solid rgba(239,68,68,.35);border-radius:7px;padding:8px;font-size:11px;line-height:1.5}' +
    '.eohls-skel{height:12px;border-radius:6px;margin:7px 0;background:linear-gradient(90deg,rgba(90,130,180,.10) 25%,rgba(120,170,255,.26) 50%,rgba(90,130,180,.10) 75%);background-size:200% 100%;animation:eohlsShim 1.3s ease-in-out infinite}' +
    '@keyframes eohlsShim{0%{background-position:200% 0}100%{background-position:-200% 0}}';

  function ensureStyle(doc) {
    if (doc.getElementById('eohls-css')) return;
    var st = doc.createElement('style'); st.id = 'eohls-css'; st.textContent = CSS;
    // In the window.open('about:blank') fallback the document can have no <head> yet;
    // appending to a null head threw and killed the whole panel mount silently.
    var host = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement || doc.body;
    if (host) host.appendChild(st);
  }

  // Bulletproof interception: rebind the guide button to OUR flow directly, so it
  // can't fall through to the old guide regardless of wrap/load-order.
  function bindGuideBtn(doc) {
    try {
      var gb = doc.getElementById('eohg-guidebtn');
      if (!gb || gb.__lsBound) return;
      var gb2 = gb.cloneNode(true); gb2.__lsBound = true;
      if (gb.parentNode) gb.parentNode.replaceChild(gb2, gb);
      gb2.addEventListener('click', function () {
        var q = ''; try { q = (doc.getElementById('q').value || '').trim(); doc.getElementById('q').value = ''; } catch (e) {}
        // If the box is empty (e.g. the request was spoken via the mic and went to the
        // answer flow), fall back to the last thing the user said/typed this session.
        if (!q) {
          try {
            var H = (global.S && global.S.history) || [];
            for (var i = H.length - 1; i >= 0; i--) { if (H[i] && H[i].role === 'user' && H[i].content) { q = String(H[i].content).trim(); break; } }
          } catch (e) {}
        }
        try { console.log('[EOHLiveScreen] guide button → understanding, q=', q); } catch (e) {}
        ask(q);
      });
    } catch (e) {}
  }

  function mountPanel(doc) {
    LS.doc = doc; ensureStyle(doc);
    bindGuideBtn(doc);
    if (doc.getElementById('eohls-panel')) { return; }
    var panel = doc.createElement('div');
    panel.id = 'eohls-panel';
    panel.innerHTML =
      '<div id="eohls-head"><span class="t">🖥️ EOH Live Screen</span><button id="eohls-min" title="Collapse">▾</button></div>' +
      '<div id="eohls-body"></div>';
    // Put it right after the Ask row (above the guide preview) if possible.
    var askRow = doc.querySelector('.qr');
    if (askRow && askRow.parentNode) askRow.parentNode.insertBefore(panel, askRow.nextSibling);
    else doc.body.insertBefore(panel, doc.body.firstChild);
    var head = doc.getElementById('eohls-head');
    if (head) head.addEventListener('click', function () { collapse(!LS.collapsed); });
    try { console.log('[EOHLiveScreen] panel mounted (#eohls-panel) — new Live Screen UI active'); } catch (e) {}
    render();
  }

  function collapse(on) {
    LS.collapsed = on; var doc = LS.doc; if (!doc) return;
    var bodyEl = doc.getElementById('eohls-body');
    var minBtn = doc.getElementById('eohls-min');
    if (bodyEl) bodyEl.style.display = on ? 'none' : 'block';
    if (minBtn) minBtn.textContent = on ? '▸' : '▾';
    var reopen = doc.getElementById('eohls-reopen'); if (reopen) reopen.remove();   // no floating button
  }

  function body() { return LS.doc && LS.doc.getElementById('eohls-body'); }

  // Inline text input inside the PiP panel, with a 🎤 dictation option.
  var _dictRec = null;
  function _stopDictation() { try { if (_dictRec) { _dictRec.stop(); _dictRec = null; } } catch (e) {} }
  function _toggleDictation(ta, btn, statusEl) {
    if (_dictRec) { _stopDictation(); if (btn) btn.textContent = '🎤 Speak'; if (statusEl) statusEl.textContent = ''; return; }
    var SR = global.SpeechRecognition || global.webkitSpeechRecognition;
    if (!SR) { if (statusEl) statusEl.textContent = 'Voice input isn\u2019t available in this browser — please type.'; return; }
    try {
      _dictRec = new SR();
      _dictRec.lang = (typeof lang === 'function' && lang()) || 'en-US';
      _dictRec.interimResults = true; _dictRec.continuous = true;
      var base = ta.value ? (ta.value.replace(/\s+$/, '') + ' ') : '';
      _dictRec.onresult = function (e) { var txt = ''; for (var i = 0; i < e.results.length; i++) txt += e.results[i][0].transcript; ta.value = base + txt; };
      _dictRec.onerror = function () { _dictRec = null; if (btn) btn.textContent = '🎤 Speak'; if (statusEl) statusEl.textContent = 'Mic busy — please type instead.'; };
      _dictRec.onend = function () { _dictRec = null; if (btn) btn.textContent = '🎤 Speak'; if (statusEl) statusEl.textContent = ''; };
      _dictRec.start();
      if (btn) btn.textContent = '⏹ Stop';
      if (statusEl) statusEl.textContent = '🔴 Listening… speak now, then tap Stop.';
    } catch (e) { _dictRec = null; if (statusEl) statusEl.textContent = 'Could not start the mic — please type.'; }
  }

  function askFreeText(label, placeholder, cb) {
    var b = body(); if (!b) return;
    b.innerHTML = '<div class="eohls-hint">' + esc(label) + '</div>' +
      '<textarea id="eohls-ft" rows="2" style="width:100%;box-sizing:border-box;background:#0b1017;border:1px solid rgba(90,130,180,.45);border-radius:7px;padding:8px;color:#e2eefb;font-size:12px;font-family:inherit;resize:vertical;outline:none" placeholder="' + esc(placeholder || 'Type or tap 🎤 Speak…') + '"></textarea>' +
      '<div class="eohls-row"><button class="eohls-btn" data-ftok="1">Continue →</button><button class="eohls-btn ghost" data-ftmic="1">🎤 Speak</button><button class="eohls-btn ghost" data-ftcancel="1">Cancel</button></div>' +
      '<div id="eohls-ftstatus" class="eohls-hint" style="margin-top:5px"></div>';
    var ta = b.querySelector('#eohls-ft'); try { ta.focus(); } catch (e) {}
    var statusEl = b.querySelector('#eohls-ftstatus');
    ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { _stopDictation(); var t = (ta.value || '').trim(); if (t) cb(t); } });
    b.querySelector('[data-ftok]').onclick = function () { _stopDictation(); var t = (ta.value || '').trim(); if (t) cb(t); };
    b.querySelector('[data-ftcancel]').onclick = function () { _stopDictation(); render(); };
    b.querySelector('[data-ftmic]').onclick = function () { _toggleDictation(ta, this, statusEl); };
  }

  function render() {
    var b = body(); if (!b) return;
    if (LS.stage === 'idle') { b.innerHTML = '<div class="eohls-hint">🎤 Use the mic or type what you want to do, then tap <b>Guide me</b>. EOH will first confirm what you mean, then map it into phases.</div>'; return; }
    if (LS.stage === 'interp') return renderInterp(b);
    if (LS.stage === 'phases') return renderPhases(b);
    if (LS.stage === 'guiding') return renderGuiding(b);
    if (LS.stage === 'code')   return renderCode(b);
    if (LS.stage === 'blocked') return; // handled inline
  }

  function renderInterp(b) {
    var h = '<div class="eohls-hint">Did you mean…?</div>';
    (LS.interps || []).forEach(function (it, i) {
      h += '<button class="eohls-opt' + (it.recommended ? ' rec' : '') + '" data-i="' + i + '">' + esc(it.label) +
        (it.area ? '<small>' + esc(it.area) + (it.touches && it.touches.length ? ' · ' + esc(it.touches.join(', ')) : '') + '</small>' : '') + '</button>';
    });
    h += '<button class="eohls-opt" data-free="1">✎ None of these — I\'ll describe it</button>';
    h += '<div class="eohls-row"><button class="eohls-btn ghost" data-reclarify="1">↺ Re-clarify</button><button class="eohls-btn ghost" data-end="1">End</button></div>';
    b.innerHTML = h;
    Array.prototype.forEach.call(b.querySelectorAll('[data-i]'), function (el) { el.onclick = function () { chooseInterp(LS.interps[+el.dataset.i]); }; });
    var free = b.querySelector('[data-free]'); if (free) free.onclick = function () { askFreeText('Describe what you want to do:', 'e.g. set up a new approval workflow for POs…', function (t) { chooseInterp({ label: t, free_text: true }); }); };
    var rc = b.querySelector('[data-reclarify]'); if (rc) rc.onclick = reclarify;
    var en = b.querySelector('[data-end]'); if (en) en.onclick = endTask;
  }

  function renderPhases(b) {
    var h = '<div class="eohls-hint">Full cycle · ' + (LS.phases.length) + ' phases · pick one to start</div>';
    LS.phases.forEach(function (p, i) {
      var st = (LS.phaseStates && LS.phaseStates[p.id]) || {};
      h += '<button class="eohls-ph ' + (st.status === 'done' ? 'done' : '') + (LS.activePhase === p.id ? ' active' : '') + '" data-p="' + esc(p.id) + '">' +
        '<span class="num">' + (st.status === 'done' ? '✓' : (i + 1)) + '</span>' +
        '<span class="ttl">' + esc(p.title) + (p.code ? ' <span class="code">&lt;/&gt;</span>' : '') + '</span></button>';
    });
    var allDone = LS.phases.every(function (p) { return LS.phaseStates && LS.phaseStates[p.id] && LS.phaseStates[p.id].status === 'done'; });
    h += '<div class="eohls-row">' + (allDone ? '<button class="eohls-btn" data-end="1">Finish task ✓</button>' : '') +
      '<button class="eohls-btn ghost" data-reclarify="1">↺ Re-clarify</button><button class="eohls-btn ghost" data-end="1">End task</button></div>';
    b.innerHTML = h;
    Array.prototype.forEach.call(b.querySelectorAll('[data-p]'), function (el) { el.onclick = function () { pickPhase(el.dataset.p); }; });
    var rc = b.querySelector('[data-reclarify]'); if (rc) rc.onclick = reclarify;
    Array.prototype.forEach.call(b.querySelectorAll('[data-end]'), function (el) { el.onclick = endTask; });
  }

  // ── Lightweight multi-language syntax highlighter (single pass; comments/strings
  //    first so keywords inside them aren't coloured). Works for ABAP/SQL/Python/JS/… ──
  var _KW = /^(?:report|parameters?|data|types?|tables?|constants?|start-of-selection|perform|form|endform|write|move|append|read|select|endselect|from|into|where|order|group|having|by|insert|update|modify|delete|call|function|module|method|methods|class|endclass|interface|public|private|protected|section|if|elseif|else|endif|case|when|endcase|do|enddo|while|endwhile|loop|endloop|for|in|def|return|import|export|as|with|lambda|yield|async|await|try|except|finally|raise|throw|catch|switch|default|break|continue|pass|print|echo|var|let|const|new|typeof|instanceof|void|null|true|false|none|undefined|this|self|super|extends|implements|enum|package|begin|end|create|alter|drop|view|join|inner|outer|left|right|on|and|or|not|is|like|between|values|set|primary|key|foreign|references|declare|cursor|open|fetch|close|commit|rollback)$/i;
  function _hl(code) {
    function e(x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    var out = '', i = 0, L = code.length, m, rest;
    var reC = /^(\/\*[\s\S]*?\*\/|\/\/[^\n]*|#[^\n]*|--[^\n]*)/,
        reS = /^("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`)/,
        reN = /^(\d+(?:\.\d+)?)/, reWs = /^(\s+)/, reW = /^([A-Za-z_][A-Za-z0-9_-]*)/;
    while (i < L) {
      rest = code.slice(i);
      if (m = rest.match(reC)) { out += '<span class="c">' + e(m[1]) + '</span>'; i += m[1].length; continue; }
      if (m = rest.match(reS)) { out += '<span class="s">' + e(m[1]) + '</span>'; i += m[1].length; continue; }
      if (m = rest.match(reN)) { out += '<span class="n">' + e(m[1]) + '</span>'; i += m[1].length; continue; }
      if (m = rest.match(reWs)) { out += e(m[1]); i += m[1].length; continue; }
      if (m = rest.match(reW)) { out += (_KW.test(m[1]) ? '<span class="k">' + e(m[1]) + '</span>' : e(m[1])); i += m[1].length; continue; }
      out += e(code[i]); i++;
    }
    return out;
  }

  function renderCode(b) {
    var p = LS.codePhase || {};
    var codeHtml = LS.codeText ? _hl(LS.codeText) : '<span class="c">// generating code…</span>';
    b.innerHTML =
      '<div class="eohls-hint">' + esc(p.title || 'Code') + '</div>' +
      '<div class="eohls-codehdr"><span class="lang">' + esc(LS.codeLang || p.code_language || 'code') + '</span>' +
        '<button data-copy="1">⧉ Copy</button><button data-regen="1">↻ Regenerate</button></div>' +
      '<pre class="eohls-code"><code>' + codeHtml + '</code></pre>' +
      (LS.codeNotes ? '<div class="eohls-note">⚠ ' + esc(LS.codeNotes) + '</div>' : '') +
      '<div class="eohls-row"><button class="eohls-btn ghost" data-guide="1">Guide me to enter it</button><button class="eohls-btn" data-done="1">Done ✓</button><button class="eohls-btn ghost" data-back="1">← Phases</button></div>';
    var cp = b.querySelector('[data-copy]'); if (cp) cp.onclick = function () { try { (LS.doc.defaultView || global).navigator.clipboard.writeText(LS.codeText || ''); cp.textContent = '✓ Copied'; setTimeout(function () { cp.textContent = '⧉ Copy'; }, 1500); } catch (e) {} };
    var rg = b.querySelector('[data-regen]'); if (rg) rg.onclick = function () { generateCode(p.id, true); };
    var gd = b.querySelector('[data-guide]'); if (gd) gd.onclick = function () { guideDetail((p.title || '') + (LS.codeText ? ' — enter this code:\n' + LS.codeText : '')); };
    var dn = b.querySelector('[data-done]'); if (dn) dn.onclick = function () { markDone(p.id); };
    var bk = b.querySelector('[data-back]'); if (bk) bk.onclick = function () { LS.stage = 'phases'; render(); };
  }

  // Generate the real code for a code phase, then show it highlighted.
  async function generateCode(pid, regen) {
    var p = LS.phases.find(function (x) { return x.id === pid; }); if (!p) return;
    LS.codePhase = p; LS.stage = 'code';
    if (regen) { LS.codeText = ''; LS.codeLang = p.code_language || ''; LS.codeNotes = ''; }
    render();
    var img = await frame();
    var d = await api('/live-screen/session/' + LS.sessionId + '/code', { phase_id: pid, image: img, lang: lang(), regen: !!regen });
    if (d.error) { LS.codeText = '// ' + d.error; render(); return; }
    LS.codeText = d.code || ''; LS.codeLang = d.language || p.code_language || ''; LS.codeNotes = d.notes || ''; render();
  }

  // ── FLOW ───────────────────────────────────────────────────────────────────
  async function ask(q, forceNew) {
    q = String(q || '').trim();
    try { console.log('[EOHLiveScreen] Guide me tapped, request=', q, 'forceNew=', !!forceNew); } catch (e) {}
    if (!q) { collapse(false); setBusy('Type or say what you want to do first, then tap Guide me.'); return; }
    setBusy('Understanding your request…');
    var img = await frame();
    if (!img) { setBusy('Couldn\u2019t capture your screen. Make sure screen sharing is active, then tap Guide me again.'); return; }
    var d = await api('/live-screen/understand', { image: img, request: q, lang: lang(), vendor: (global.S && S.vendor) || null, product: (global.S && S.product) || null, mem_session: (global.S && S.sessionId) || null, force_new: !!forceNew });
    try { console.log('[EOHLiveScreen] understand →', d); } catch (e) {}
    if (d.disabled) { setBusy('EOH Live Screen is off — enable "live_screen_understanding" in Feature Flags.'); setTimeout(function () { fallback(q); }, 1400); return; }
    if (d.blocked) { LS.pendingReq = q; renderBlocked(d.active_session, q); return; }
    if (d.error || !d.session_id) { setBusy(d.error || 'Could not analyze the screen.'); return; }
    LS.sessionId = d.session_id; LS.interps = d.interpretations || []; LS.stage = 'interp'; collapse(false); render();
  }

  async function chooseInterp(it) {
    setBusy('Mapping the phases…');
    await api('/live-screen/session/' + LS.sessionId + '/choose', { interpretation: it });
    var img = await frame();
    var d = await api('/live-screen/session/' + LS.sessionId + '/phases', { image: img, lang: lang() });
    if (d.error || !d.phases) { setBusy(d.error || 'Could not map phases.'); return; }
    LS.phases = d.phases; LS.phaseStates = {}; LS.phases.forEach(function (p) { LS.phaseStates[p.id] = { status: 'pending' }; });
    LS.stage = 'phases'; render();
  }

  async function pickPhase(pid) {
    var p = LS.phases.find(function (x) { return x.id === pid; });
    if (!p) return;
    if (LS.phaseStates[pid] && LS.phaseStates[pid].status === 'done') { LS.stage = 'phases'; render(); return; }
    LS.activePhase = pid;
    var d = await apiGet('/live-screen/session/' + LS.sessionId + '/phase/' + pid);
    var phase = (d && d.phase) || {};
    var detail = phase.detail || p.title;
    LS.curDetail = detail;
    LS.curCtx = buildPlanCtx(d, phase, p);   // rich context so the guide follows the AGREED plan
    await api('/live-screen/session/' + LS.sessionId + '/phase-state', { phase_id: pid, status: 'active' });
    LS.phaseStates[pid] = { status: 'active' };
    if (p.code) { generateCode(pid); }   // code phase → generate + show highlighted code
    else { guideDetail(detail); }         // guideDetail sets stage='guiding' and renders the controls
  }

  // Anchor the guide to the plan the user already agreed to, so it can't wander into
  // a different interpretation once it starts producing steps.
  function buildPlanCtx(d, phase, p) {
    var goal = (d && d.chosen && d.chosen.label) || (d && d.request) || '';
    var mapLines = (LS.phases || []).map(function (x, i) { return (i + 1) + '. ' + x.title + (x.id === (p && p.id) ? '   ← CURRENT PHASE' : ''); }).join('\n');
    return 'IMPORTANT: The user has ALREADY agreed to a specific plan. Guide ONLY the current phase, consistent with the overall goal and the agreed phase map. Do NOT switch to a different interpretation or invent a different approach.\n\n' +
      'THIS PHASE IS SELF-CONTAINED — treat it as a fresh, standalone process:\n' +
      '• The user has just finished the PREVIOUS phase and is very likely STILL ON THE PREVIOUS SCREEN (or somewhere else entirely). They have NOT yet navigated to this phase. Do NOT assume they are already at this phase\'s location, and do NOT keep guiding the previous phase\'s screen.\n' +
      '• STEP 1 must be: read the CURRENT screen to see where they actually are, then NAVIGATE them from there to THIS phase\'s starting point (open the correct transaction / IMG node / table / menu / app). Only once they arrive, guide the phase\'s real steps.\n' +
      '• END the phase cleanly (save / go back) so the next phase can start fresh from a known place.\n' +
      '• Many screens, tables, and objects have SIMILAR names — identify the user\'s real location from what is on screen, never by assuming continuity from the previous phase.\n\n' +
      'Overall goal: ' + goal + '\n\nAgreed phase map (in order):\n' + mapLines + '\n\n' +
      'CURRENT PHASE to guide now: "' + (phase.title || (p && p.title) || '') + '"\n' +
      'What this phase must accomplish: ' + (phase.detail || '') + '\n\n' +
      'Give the exact, correct, verified steps for THIS phase only. If you are not sure of a specific identifier, ask a short clarify instead of guessing.';
  }

  // Hand ONE phase to the existing guide engine (boxes + captions), then let the
  // user mark it done from the phase list.
  function guideDetail(detail) {
    collapse(false);
    try { if (LS.curCtx && global.EOHGuide) EOHGuide.planCtx = LS.curCtx; } catch (e) {}
    try { if (global.EOHGuide) EOHGuide.busy = false; } catch (e) {}   // allow a fresh re-plan (fixes Redirect/Re-scan)
    try { if (EOHGuide._origStartGuide) EOHGuide._origStartGuide(detail); } catch (e) {}
    LS.stage = 'guiding'; render();
  }

  // Beginner-friendly guiding view: shows the CURRENT step in plain words + a big Next button.
  function renderGuiding(b) {
    var p = (LS.phases || []).find(function (x) { return x.id === LS.activePhase; }) || {};
    var G = global.EOHGuide || {};
    var total = (G.plan && G.plan.total) || 0;
    var idx = (G.idx || 0) + 1;
    var stepText = '';
    try { stepText = ((LS.doc.getElementById('eohg-cap') || {}).textContent || '').trim(); } catch (e) {}
    if (!stepText && G.plan && G.plan.steps && G.plan.steps[G.idx]) stepText = G.plan.steps[G.idx].say || '';
    var isLast = total && idx >= total;

    b.innerHTML =
      '<div class="eohls-hint">📍 <b>' + esc(p.title || 'this phase') + '</b>' + (total ? ' — step ' + idx + ' of ' + total : '') + '</div>' +
      (stepText
        ? '<div style="font-size:13px;color:#e2eefb;line-height:1.55;background:rgba(30,42,60,.6);border:1px solid rgba(90,130,180,.35);border-radius:8px;padding:10px 12px;margin-bottom:9px">' + esc(stepText) + '</div>'
        : '<div class="eohls-hint" style="margin-bottom:9px">Follow the red highlight on your screen, then tap <b>Next</b>.</div>') +
      '<div class="eohls-row">' +
        (isLast
          ? '<button class="eohls-btn" data-g="done" style="flex:1">✓ I finished this phase</button>'
          : '<button class="eohls-btn" data-g="next" style="flex:1">Next step →</button>') +
      '</div>' +
      '<div class="eohls-row" style="margin-top:8px">' +
        '<button class="eohls-btn ghost" data-g="redirect">✏️ Fix / redirect</button>' +
        '<button class="eohls-btn ghost" data-g="rescan">🔄 Re-scan</button>' +
      '</div>' +
      '<div class="eohls-row">' +
        (isLast ? '' : '<button class="eohls-btn ghost" data-g="done">✓ Done early</button>') +
        '<button class="eohls-btn ghost" data-g="report">⚑ Wrong?</button>' +
        '<button class="eohls-btn ghost" data-g="phases">← Phases</button>' +
      '</div>';

    var by = function (k) { return b.querySelector('[data-g="' + k + '"]'); };
    if (by('next')) by('next').onclick = function () {
      var G = global.EOHGuide;
      if (!G) return;
      if (G.busy) return;   // already checking your screen — ignore extra taps (no re-shimmer, no hang)
      setBusy('Checking your screen…');
      try { clearTimeout(LS._nextTimer); } catch (e) {}
      LS._nextTimer = setTimeout(function () { if (LS.stage === 'guiding') render(); }, 15000);   // safety net: never hang
      try { G.next(); } catch (e) { render(); }
    };
    Array.prototype.forEach.call(b.querySelectorAll('[data-g="done"]'), function (el) { el.onclick = function () { markDone(LS.activePhase); }; });
    by('redirect').onclick = function () { askFreeText('What should it do differently? (stays in THIS phase)', 'e.g. no, use SM30 not SE16 — or — I meant the US grouping', correctPhase); };
    by('rescan').onclick = function () { if (LS.curDetail) guideDetail(LS.curDetail); };
    by('report').onclick = reportStep;
    by('phases').onclick = function () { LS.stage = 'phases'; render(); };
  }

  // Steer the CURRENT phase with a user correction — re-plans this phase only, no session restart.
  function correctPhase(text) {
    if (!text) { LS.stage = 'guiding'; render(); return; }
    setBusy('Adjusting…');
    var corr = '\n\nUSER CORRECTION (HIGHEST PRIORITY — the previous guidance was wrong or headed the wrong way; override the earlier steps to honor this): ' + text;
    if (LS.curCtx) LS.curCtx += corr;                 // fold into the plan context so it sticks
    guideDetail((LS.curDetail || '') + corr);         // re-guide THIS phase, incorporating the correction
  }

  // Report a wrong step → logs it (+ optional screenshot) for the accuracy dataset.
  function reportStep() {
    var b = body(); if (!b) return;
    var stepText = ''; try { stepText = ((LS.doc.getElementById('eohg-cap') || {}).textContent || '').trim(); } catch (e) {}
    var conf = (global.EOHGuide && EOHGuide.confidence) || null;
    var ph = (LS.phases || []).find(function (x) { return x.id === LS.activePhase; }) || {};
    b.innerHTML =
      '<div class="eohls-hint">⚑ Report a wrong step</div>' +
      (stepText ? '<div class="eohls-hint" style="color:#8aa0b8;margin-bottom:6px">Shown: ' + esc(stepText.slice(0, 140)) + '</div>' : '') +
      '<textarea id="eohls-rep" rows="2" style="width:100%;box-sizing:border-box;background:#0b1017;border:1px solid rgba(90,130,180,.45);border-radius:7px;padding:8px;color:#e2eefb;font-size:12px;font-family:inherit;resize:vertical;outline:none" placeholder="What was wrong? e.g. it should be SE80, not SE38"></textarea>' +
      '<label style="display:flex;align-items:center;gap:6px;font-size:11px;color:#9fb6cf;margin:6px 0"><input type="checkbox" id="eohls-repshot" checked> Attach current screenshot</label>' +
      '<div class="eohls-row"><button class="eohls-btn" data-repsend="1">Send</button><button class="eohls-btn ghost" data-repcancel="1">Cancel</button></div>';
    var ta = b.querySelector('#eohls-rep'); try { ta.focus(); } catch (e) {}
    b.querySelector('[data-repcancel]').onclick = function () { LS.stage = 'guiding'; render(); };
    b.querySelector('[data-repsend]').onclick = async function () {
      var note = (ta.value || '').trim();
      var shot = null;
      if (b.querySelector('#eohls-repshot').checked) { try { shot = await frame(); } catch (e) {} }
      setBusy('Sending…');
      await api('/live-screen/session/' + LS.sessionId + '/report', {
        phase_id: LS.activePhase, phase_title: ph.title || '', step_text: stepText,
        confidence: conf, note: note, screenshot: shot
      });
      setBusy('✓ Thanks — logged. We\u2019ll use this to improve.');
      setTimeout(function () { LS.stage = 'guiding'; render(); }, 1600);
    };
  }
  async function markDone(pid) {
    if (!pid) return;
    var d = await api('/live-screen/session/' + LS.sessionId + '/phase-state', { phase_id: pid, status: 'done' });
    LS.phaseStates[pid] = { status: 'done' }; LS.activePhase = null; LS.stage = 'phases';
    try { if (global.EOHGuide && EOHGuide.reset) { /* keep preview; just clear controls */ } } catch (e) {}
    render();
    if (d && d.all_done) setBusy('All phases done — tap “Finish task”.');
  }

  function reclarify() {
    askFreeText('Refine — what did you actually mean?', 'e.g. I meant the CATS side, not time evaluation…', doReclarify);
  }
  async function doReclarify(t) {
    setBusy('Re-checking…');
    var img = await frame();
    var d = await api('/live-screen/session/' + LS.sessionId + '/reclarify', { image: img, text: t, lang: lang() });
    if (d.error) { setBusy(d.error); return; }
    LS.interps = d.interpretations || []; LS.stage = 'interp'; render();
  }

  async function endTask() {
    if (LS.sessionId) await api('/live-screen/session/' + LS.sessionId + '/end', {});
    LS.sessionId = null; LS.phases = []; LS.phaseStates = {}; LS.activePhase = null; LS.stage = 'idle';
    try { if (global.EOHGuide && EOHGuide.reset) EOHGuide.reset(); } catch (e) {}
    render();
  }

  function renderBlocked(active, newReq) {
    LS.stage = 'blocked'; var b = body(); if (!b) return; collapse(false);
    var openTitle = (active && active.request) || 'your current task';
    b.innerHTML = '<div class="eohls-warn">⚠ You already have an open task:<br><b>' + esc(openTitle) + '</b><br>Finish it, or end it to start' + (newReq ? ' <b>“' + esc(newReq) + '”</b>' : ' a new request') + '.</div>' +
      '<div class="eohls-row">' +
      ((active && active.phases && active.phases.length) ? '<button class="eohls-btn" data-resume="1">↩ Resume open task</button>' : '') +
      '<button class="eohls-btn ghost" data-endnew="1">End it & start ' + (newReq ? 'new' : 'over') + '</button></div>';
    var rs = b.querySelector('[data-resume]');
    if (rs) rs.onclick = function () {
      if (!active) return;
      LS.sessionId = active.id; LS.interps = active.interpretations || [];
      LS.phases = (active.phases || []).map(function (p) { return { id: p.id, title: p.title, kind: p.kind, code: p.code, code_language: p.code_language }; });
      LS.phaseStates = active.phase_states || {};
      LS.stage = LS.phases.length ? 'phases' : 'interp'; render();
    };
    b.querySelector('[data-endnew]').onclick = function () {
      // End the open session AND immediately process the new request (force_new).
      ask(newReq || LS.pendingReq, true);
    };
  }

  function setBusy(msg) {
    var b = body(); if (!b) return;
    var loading = /(?:…|\.\.\.)\s*$/.test(String(msg || ''));   // only shimmer while actually loading
    b.innerHTML = '<div class="eohls-hint">' + esc(msg) + '</div>' +
      (loading ? '<div class="eohls-skel"></div><div class="eohls-skel" style="width:72%"></div>' : '');
  }
  function fallback(q) { LS.stage = 'idle'; render(); try { if (EOHGuide._origStartGuide) EOHGuide._origStartGuide(q); } catch (e) {} }

  async function rehydrate() {
    try {
      var d = await apiGet('/live-screen/session/active');
      if (!d || !d.session) return;
      LS.sessionId = d.session.id;
      LS.interps = d.session.interpretations || [];
      LS.phases = (d.session.phases || []).map(function (p) { return { id: p.id, title: p.title, kind: p.kind, code: p.code, code_language: p.code_language }; });
      LS.phaseStates = d.session.phase_states || {};
      if (LS.phases.length) {
        LS.stage = 'phases'; collapse(false); render();
        // Land on the current phase: the active one, else the first not-done.
        var cur = LS.phases.find(function (p) { return LS.phaseStates[p.id] && LS.phaseStates[p.id].status === 'active'; })
          || LS.phases.find(function (p) { return !(LS.phaseStates[p.id] && LS.phaseStates[p.id].status === 'done'); });
        var b = body();
        if (cur && b) {
          var idx = LS.phases.indexOf(cur) + 1;
          var banner = LS.doc.createElement('div');
          banner.className = 'eohls-warn';
          banner.style.background = 'rgba(15,181,116,.1)'; banner.style.borderColor = 'rgba(15,181,116,.35)';
          banner.innerHTML = '↩ Welcome back — resuming <b>' + esc(d.session.request || 'your task') + '</b><br>Phase ' + idx + ' of ' + LS.phases.length + ': ' + esc(cur.title) +
            '<div class="eohls-row"><button class="eohls-btn" data-resumephase="1">Continue phase ' + idx + '</button></div>';
          b.insertBefore(banner, b.firstChild);
          var rb = banner.querySelector('[data-resumephase]'); if (rb) rb.onclick = function () { pickPhase(cur.id); };
        }
      } else {
        LS.stage = LS.interps.length ? 'interp' : 'idle'; render();
      }
    } catch (e) {}
  }

  // ── INSTALL: wrap the existing client once it's present ──────────────────────
  function install() {
    if (!global.EOHGuide || global.EOHGuide.__lsWrapped) return;
    var G = global.EOHGuide;
    G.__lsWrapped = true;
    G._origStartGuide = G.startGuide;
    G.startGuide = function (q) { ask(q); };
    var _origMount = G.mountPanel;
    G.mountPanel = function (d) {
      try { _origMount(d); } catch (e) { try { console.error('[EOHLiveScreen] original mountPanel failed:', e); } catch (_) {} }
      // These were silently swallowed — a throw here left ONLY the old guide panel visible
      // with no error, which looks exactly like "the new version didn't deploy".
      try { mountPanel(d); } catch (e) { try { console.error('[EOHLiveScreen] mountPanel FAILED:', e); } catch (_) {} }
      try { rehydrate(); } catch (e) { try { console.error('[EOHLiveScreen] rehydrate failed:', e); } catch (_) {} }
    };
    var _origReset = G.reset;
    G.reset = function () { try { _origReset(); } catch (e) {} };   // keep understanding session alive across guide resets
    try { console.log('[EOHLiveScreen] installed — startGuide + mountPanel wrapped'); } catch (e) {}
    // Refresh the guiding view whenever the guide renders/advances a step.
    try { G.onStep = function () { try { clearTimeout(LS._nextTimer); } catch (e) {} if (LS.stage === 'guiding') render(); }; } catch (e) {}
  }

  if (global.EOHGuide) install();
  else { var _n = 0, _iv = setInterval(function () { if (global.EOHGuide || ++_n > 40) { clearInterval(_iv); install(); } }, 150); }

  global.EOHLiveScreen = { ask: ask, endTask: endTask, _state: LS };
})(window);
